jQuery.noConflict();
jQuery(document).ready(function () {
    if ($('.twostepsequal').length > 0) {
        $(".twostepsequal_descriptionstep2").hide();
        $(".twostepsequal_descriptionstep3").hide();


        // On va compter le nombre de div de l'étape 1
        let count = $(".twostepsequal_item1").length;
        // On va diviser la largeur en partie égale pour chaque partie
        $(".twostepsequal_item").css({ 'width': 'calc(100% - 100px)' });


        $(document).ready(function () {


            $(".twostepsequal_button1").click(function () {
                $("#twostepsequal_2").removeClass("twostepsequal_actif")
                $("#twostepsequal_3").removeClass("twostepsequal_actif")
                if ($(".twostepsequal_descriptionstep1").is(":visible")) {
    
                }
                else {
                    if ($(".twostepsequal_descriptionstep1").is(":hidden")) {
                        $(".twostepsequal_descriptionstep1").show();

                        $(".twostepsequal_descriptionstep2").hide();
                        $(".twostepsequal_descriptionstep3").hide();
                    }
                }
            });

            $(".twostepsequal_button2").click(function () {
                $("#twostepsequal_2").addClass("twostepsequal_actif")
                $("#twostepsequal_3").removeClass("twostepsequal_actif")
                if ($(".twostepsequal_descriptionstep2").is(":visible")) {
                   
                }
                else {
                    if ($(".twostepsequal_descriptionstep2").is(":hidden")) {
                        $(".twostepsequal_descriptionstep2").show();

                        $(".twostepsequal_descriptionstep1").hide();
                        $(".twostepsequal_descriptionstep3").hide();
                    }
                }
            });

            $(".twostepsequal_button3").click(function () {
                $("#twostepsequal_3").addClass("twostepsequal_actif")
                $("#twostepsequal_2").addClass("twostepsequal_actif")
                if ($(".twostepsequal_descriptionstep3").is(":visible")) {
                    
                }
                else {
                    if ($(".twostepsequal_descriptionstep3").is(":hidden")) {
                        $(".twostepsequal_descriptionstep3").show();

                        $(".twostepsequal_descriptionstep1").hide();
                        $(".twostepsequal_descriptionstep2").hide();
                    }
                }
            });
        });


    };
});
